import { HttpInterceptorFn } from '@angular/common/http';
import { resolveAppLocale } from '../config/app-locale';

export const httpLocaleInterceptor: HttpInterceptorFn = (req, next) => {
  return next(
    req.clone({
      setHeaders: {
        'Accept-Language': resolveAppLocale(),
      },
    }),
  );
};
